import React, { useCallback, useEffect } from 'react';
import { Icon } from '@vectord/components';
import { useDispatch } from 'react-redux';

import {
  COURSE_PAUSE_RESCHEDULE_MODAL_STAGES,
  setCoursePauseRescheduleModalStage,
} from 'features/courseResume';
import styles from './CoursePauseRescheduleModalSuccessStage.module.scss';

function CoursePauseRescheduleModalSuccessStage() {
  const dispatch = useDispatch();

  const handleNextRequest = useCallback(() => {
    dispatch(
      setCoursePauseRescheduleModalStage(
        COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.notOpen
      )
    );
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleNextRequest();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, handleNextRequest]);

  return (
    <div className={styles.root}>
      <div className={styles.success}>
        <Icon
          name="tick-circle"
          className="h1 success bold m-b-m"
        />
        <div className="h2 bold m-b-xs">Resume Rescheduled Successfully</div>
      </div>
    </div>
  );
}

export default CoursePauseRescheduleModalSuccessStage;
